/** Only Google's documented, already-hashed identifiers may reach gtag. */
const SHA256_HEX = /^[a-f0-9]{64}$/i;

export function googleTagUserData(data: Readonly<Record<string, unknown>>): Record<string, string> {
  const result: Record<string, string> = {};
  const email = data.em_g || data.em;
  if (typeof email === "string" && SHA256_HEX.test(email)) result.sha256_email_address = email.toLowerCase();
  // ph is the digits-only hash used by other platforms. Google needs E.164.
  if (typeof data.ph_e === "string" && SHA256_HEX.test(data.ph_e)) result.sha256_phone_number = data.ph_e.toLowerCase();
  return result;
}
